import React, { useEffect } from 'react';
import './Modal.css';

interface ModalProps {
    open: boolean;
    onClose: () => void;
    children: React.ReactNode;
    closeOnOverlayClick?: boolean;
    closeOnEscape?: boolean;
    showCloseButton?: boolean;
    expanded?: boolean;
}

const Modal: React.FC<ModalProps> = ({
    open,
    onClose,
    children,
    closeOnOverlayClick = true,
    closeOnEscape = true,
    showCloseButton = true,
    expanded = false,
}) => {
    // Prevent body scroll when modal is open
    useEffect(() => {
        if (open) {
            const originalOverflow = document.body.style.overflow;
            document.body.style.overflow = 'hidden';
            const handleKeyDown = (e: KeyboardEvent) => {
                if (closeOnEscape && e.key === 'Escape') {
                    onClose();
                }
            };
            window.addEventListener('keydown', handleKeyDown);
            return () => {
                document.body.style.overflow = originalOverflow;
                window.removeEventListener('keydown', handleKeyDown);
            };
        }
    }, [open, onClose, closeOnEscape]);

    if (!open) return null;
    return (
        <div
            className="modal-overlay"
            onClick={closeOnOverlayClick ? onClose : undefined}
        >
            <div className={`modal-content${expanded ? ' modal-content-expanded' : ''}`} onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    {showCloseButton ? (
                        <button
                            className="modal-close"
                            aria-label="Cerrar"
                            onClick={onClose}
                        >
                            ×
                        </button>
                    ) : null}
                </div>
                <div className="modal-body">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Modal;
